import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-background-100/50 to-background-50"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-6 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              {heroData.title}
            </h1>

            <p className="mt-4 text-base md:text-lg text-primary-600 font-medium font-heading">
              {heroData.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleClick(heroData.primaryCta.href)}
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                {heroData.primaryCta.label}
              </button>
              <button
                onClick={() => handleClick(heroData.secondaryCta.href)}
                className="px-8 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                {heroData.secondaryCta.label}
              </button>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-lg overflow-hidden">
              <img
                src={heroData.image}
                alt="黑料吃瓜网主视觉 - 每日大赛热榜实时追踪"
                title="黑料吃瓜网每日大赛热榜"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <div className="animate-bounce">
          <i className="ri-arrow-down-s-line text-2xl text-foreground-400"></i>
        </div>
      </div>
    </section>
  );
}